import React, { useEffect, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

const PopupBox=(props)=>{
  const [show, setShow] = useState(false);

  const handleClose = () => props.setShow(false);
  useEffect(()=>{
    setShow(props.show)
  },[props.show])
  return (
    

      <Modal show={show} onHide={handleClose} className=' ' >
        
        <Modal.Body className='popup'>
          <small> {props.text}</small>
         </Modal.Body>
        {/* <Modal.Footer>
          <Button variant="secondary" onClick={handleClose} className='w-100 bg-success pt-3 pb-3'>
            متوجه شدم
          </Button>
          
        </Modal.Footer> */}
      </Modal>
    
  );
}
export default PopupBox;